import { useQuery } from '@tanstack/react-query';
import { dataService, Probe } from '../services/data';

export function useProbes(loggerId?: string) {
  return useQuery<Probe[], Error>({
    queryKey: ['probes', loggerId],
    queryFn: () => dataService.getProbes(loggerId),
    enabled: !!loggerId,
  });
}

export function useProbe(id: string | undefined) {
  return useQuery<Probe, Error>({
    queryKey: ['probes', id],
    queryFn: () => dataService.getProbe(id!),
    enabled: !!id,
  });
}
